<template>
	<div class="app-loading">
		<div class="spinner-border text-primary" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
	name : 'Welcome',
	methods:{
        ...mapMutations({
			'login' : 'auth/login',
			'logout' : 'auth/logout'
        })
    },
    created(){
        var token = this.$route.query.token ? this.$route.query.token : ''
        if( token ){
            this.login({token})
            this.redirect({
                name : 'Dashboard'
            })
        }else{
			this.logout()
            this.redirect({
                name : 'Install'
            })
        }
    }
}
</script>
<style lang="scss" scoped>
	.app-loading{
		height: 100vh;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>